/** Lectura y escritura de celdas: el libro mezcla fechas como número de serie y como texto, y booleanos como «Sí»/«No». */

const SERIAL_EPOCH = Date.UTC(1899, 11, 30);
const pad = (n: number) => String(n).padStart(2, '0');

export const str = (v: unknown): string => (v === null || v === undefined ? '' : String(v).trim());

export function int(v: unknown): number | null {
  if (v === '' || v === null || v === undefined) return null;
  const n = typeof v === 'number' ? v : Number(String(v).replace(',', '.'));
  return Number.isFinite(n) ? Math.round(n) : null;
}

export function bool(v: unknown): boolean | null {
  if (typeof v === 'boolean') return v;
  const s = str(v).toLowerCase();
  if (['sí', 'si', 'true', 'yes'].includes(s)) return true;
  if (['no', 'false'].includes(s)) return false;
  return null;
}

/** Día `yyyy-MM-dd`: de un número de serie de Sheets, de un texto ISO o de un texto `yyyy-MM-dd`. */
export function dateKeyOf(v: unknown): string {
  if (typeof v === 'number' && Number.isFinite(v)) {
    return new Date(SERIAL_EPOCH + Math.floor(v) * 86400000).toISOString().slice(0, 10);
  }
  const s = str(v);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;
  const dmy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  return dmy ? `${dmy[3]}-${pad(Number(dmy[2]))}-${pad(Number(dmy[1]))}` : '';
}

/**
 * Instante ISO: un texto ISO tal cual, o un número de serie con hora (las celdas Fecha-hora de Apps Script),
 * que se interpreta en la hora local del dispositivo (la del libro: España).
 */
export function isoOf(v: unknown): string {
  if (typeof v === 'number' && Number.isFinite(v)) {
    const day = new Date(SERIAL_EPOCH + Math.floor(v) * 86400000);
    const secs = Math.round((v - Math.floor(v)) * 86400);
    return new Date(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), 0, 0, secs).toISOString();
  }
  const s = str(v);
  return s && !Number.isNaN(Date.parse(s)) ? new Date(s).toISOString() : '';
}

export const boolText = (b: boolean | null) => (b === null ? '' : b ? 'Sí' : 'No');

/**
 * Texto escrito con USER_ENTERED (para que las fechas sigan siendo fechas, como las escribía Apps Script):
 * lo que empezaría como fórmula se escribe literal.
 */
export const safeText = (s: string) => (/^[=+\-@]/.test(s) ? `'${s}` : s);
